/**
 * Supply type — DOMESTIC | INTERNATIONAL — as computed by the booking engine
 * on SEARCH and echoed back on every request that follows it for that product.
 * Where the engine returns it differs by product:
 *   flight     once per search        `response.data.supplyType`
 *   hotel      per city group / hotel `data.data[].supplyType`, `totalPrice.gst.supplyType`
 *   activity   per product            `cities[].activities[].supplyType`
 * Echoed on flight check / fares, hotel rooms / availability, activity
 * availability schedule / check / confirm (top-level), and per item on
 * price/review and prebook. app-backend validates it and forwards it to the
 * engine as body `supplyType` + header `x-supply-type`.
 *
 * Only these two uppercase values are ever sent. Anything else (absent, null,
 * a typo) is OMITTED rather than sent, so the engine falls back to deriving it
 * from the partner's country itself.
 */
export type SupplyType = "DOMESTIC" | "INTERNATIONAL";

export const normalizeSupplyType = (value: unknown): SupplyType | undefined => {
  if (typeof value !== "string") return undefined;
  const v = value.trim().toUpperCase();
  return v === "DOMESTIC" || v === "INTERNATIONAL" ? v : undefined;
};

/** `{ supplyType }` when the value is valid, `{}` otherwise — spread into a request body. */
export const supplyTypeField = (value: unknown): { supplyType?: SupplyType } => {
  const supplyType = normalizeSupplyType(value);
  return supplyType ? { supplyType } : {};
};
